"use client"

import { allTools } from "@/app/(marketing)/_data/tools"
import { type Language, t } from "@/app/(marketing)/use-cases/_lib/i18n"
import Image from "next/image"

export function ToolSection({ language }: { language: Language }) {
  return (
    <section className="px-4 md:px-6 py-16 border-t border-gray-100">
      <div className="max-w-7xl mx-auto">
        <h2 className="text-lg font-semibold mb-6 text-center" style={{ color: "#26251f" }}>
          {t(
            language,
            "いつものツールと、すぐつながる",
            "Connect with your favorite tools instantly",
            "与你常用的工具，即刻连接"
          )}
        </h2>
        <div className="flex flex-wrap justify-center gap-2">
          {allTools.map((tool) => (
            <div
              key={tool.name}
              className="flex items-center gap-2 px-4 rounded-full border border-gray-200 bg-white h-10"
            >
              <Image src={tool.logo} alt={tool.name} width={20} height={20} className="w-5 h-5 object-contain" />
              <span className="text-sm" style={{ color: "#26251f" }}>
                {tool.name}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
